import React from 'react';

/**
 * Shared page header for the enterprise workspace.
 * Typography and actions only — not a decorative banner.
 */
export default function EntHero({ eyebrow, title, lead, meta, actions }) {
  return (
    <header className="ent-page-head">
      <div className="ent-page-head-text">
        {eyebrow ? <p className="ent-eyebrow">{eyebrow}</p> : null}
        <div className="ent-page-head-row">
          <h1 className="ent-page-head-title">{title}</h1>
          {actions ? <div className="ent-page-head-actions">{actions}</div> : null}
        </div>
        {lead ? <p className="ent-page-head-lead">{lead}</p> : null}
      </div>
      {meta ? <div className="ent-page-head-meta">{meta}</div> : null}
    </header>
  );
}
